import { axiosPost, axiosGet } from "../options/header";
import { handleSSEStream } from "../utils/sseStream";

export default {
  /**
   * Check ingestion status for a case
   * @param {string} caseId - The case group_url
   * @returns {Promise} Response with status and stats
   */
  async getIngestionStatus(caseId) {
    try {
      return await axiosGet(
        process.env.VUE_APP_API_ENDPOINT_STARTER + `/api/ai/case-rag/status/${caseId}`
      );
    } catch (err) {
      console.error('Failed to get case ingestion status:', err);
      throw err;
    }
  },

  /**
   * Start ingesting case files into Pinecone
   * @param {string} caseId - The case group_url
   * @returns {Promise} Response with success status
   */
  async startIngestion(caseId) {
    try {
      return await axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/case-rag/ingest",
        { caseId }
      );
    } catch (err) {
      console.error('Failed to start case ingestion:', err);
      throw err;
    }
  },

  /**
   * Query case files using RAG with streaming
   * @param {string} caseId - The case group_url
   * @param {string} question - The user's question
   * @param {Array} conversationHistory - Previous messages
   * @param {Function} onChunk - Callback for each chunk (type, data)
   * @param {Function} onComplete - Callback when stream completes
   * @param {Function} onError - Callback for errors
   */
  async queryCaseRagStream(caseId, question, conversationHistory = [], onChunk, onComplete, onError) {
    await handleSSEStream(
      process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/case-rag/query",
      { caseId, question, conversationHistory },
      onChunk,
      onComplete,
      onError
    );
  },

  /**
   * Query case files using RAG (non-streaming - deprecated, use queryCaseRagStream)
   * @param {string} caseId - The case group_url
   * @param {string} question - The user's question
   * @param {Array} conversationHistory - Previous messages
   * @returns {Promise} Response with answer and sources
   */
  async queryCaseRag(caseId, question, conversationHistory = []) {
    try {
      return await axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/case-rag/query",
        {
          caseId,
          question,
          conversationHistory
        }
      );
    } catch (err) {
      console.error('Failed to query case RAG:', err);
      throw err;
    }
  },

  /**
   * Delete case ingestion data from Pinecone
   * @param {string} caseId - The case group_url
   * @returns {Promise} Response with success status
   */
  async deleteIngestion(caseId) {
    try {
      return await axiosPost(
        process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/case-rag/delete",
        { caseId }
      );
    } catch (err) {
      console.error('Failed to delete case ingestion:', err);
      throw err;
    }
  },

  /**
   * Query the Case RAG Agent with streaming (handles both queries and actions)
   * Agent will classify intent and either answer questions or perform actions (e.g., create billing docs)
   *
   * @param {string} caseId - The case group_url
   * @param {string} message - The user's message
   * @param {string} conversationId - Optional conversation ID for multi-turn
   * @param {Function} onChunk - Callback for each chunk (type, data)
   * @param {Function} onComplete - Callback when stream completes
   * @param {Function} onError - Callback for errors
   */
  async queryCaseAgent(caseId, message, conversationId = null, onChunk, onComplete, onError) {
    await handleSSEStream(
      process.env.VUE_APP_API_ENDPOINT_STARTER + "/api/ai/case-rag/agent",
      { caseId, message, conversationId },
      onChunk,
      onComplete,
      onError
    );
  }
};
